const ResponseMessages = {
  NETWORK_ERROR: 'Network error',
  RESPONSE_NOT_JSON: 'Response is not JSON',
  JSON_PARSE_FAILED: 'Failed to parse JSON response',
} as const;

export default ResponseMessages;
